import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { CronogramaProjeto } from '../../models/cronograma-projeto.model';
import { CronogramaProjetoService } from '../../services/cronograma-projeto.service';
import { environment } from 'src/environments/environment';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { EntregasProjetoService } from '../../services/entregas-projeto.service';
import { CronogramaService } from 'src/app/shared/services/cronograma.service';

@Component({
  selector: 'app-detalhe-cronograma-projeto-list',
  templateUrl: './detalhe-cronograma-projeto-list.component.html',
  styleUrls: ['./detalhe-cronograma-projeto-list.component.scss']
})
export class DetalheCronogramaProjetoListComponent extends BaseListComponent<CronogramaProjeto> implements OnInit, OnDestroy {

  @Input() isProjeto: boolean = true;
  @Input() idEntrega: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  cronograma: CronogramaProjeto;
  link: string = environment.serverUrl;
  audit: AtualizacoesAudit;

  constructor(
    private myService: EntregasProjetoService,
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private cronogramaService: CronogramaService
  ) {
    super();
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.addSub(
      this.myService.getMonitoring(this.idEntrega).subscribe({
        next: (res) => {
          this.cronograma = res['monitoring'];
          const newStatus = this.cronogramaService.generateStatusBaseline(res['monitoring'], res['baselinePercents']);
          this.cronograma['status'] = this.cronogramaService.statusBaseLine[newStatus];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    );
  }
}
